import { contains } from 'jquery';
import React from 'react';

const CrisisManagement = () => {
  const crisisItems = [
    {
      id: 1,
      title: "Replacing Center's Post Admit Card Generation",
      icon: "presentation",
      color: "#EF4E78"
    },
    {
      id: 2,
      title: "Shifting of Center in Exigency during Exam Conduction Process",
      icon: "network",
      color: "#5B8BF5"
    },
    {
      id: 3,
      title: "Aligning transport agency for Candidates movement in case of Centre Shift",
      icon: "people",
      color: "#00B4D8"
    },
    {
      id: 4,
      title: "Buffer manpower on standby at the Centre and Head Office/ Base City",
      icon: "support",
      color: "#5B8BF5"
    },
    {
      id: 5,
      title: "Buffer hardware (Server, biometric device, camera, metal detectors) at each center",
      icon: "hardware",
      color: "#20A39E"
    },
    {
      id: 6,
      title: "Arrangement of refreshments for Candidates in case of Delay/ Water/ Toilet",
      icon: "handshake",
      color: "#FF9F43"
    }
  ];

  const getIconComponent = (iconType, color) => {
    const iconMap = {
      presentation: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="3" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/>
          <line x1="8" y1="21" x2="16" y2="21" stroke="white" strokeWidth="2"/>
          <line x1="12" y1="17" x2="12" y2="21" stroke="white" strokeWidth="2"/>
          <rect x="6" y="7" width="4" height="2" fill="white"/>
          <rect x="6" y="11" width="6" height="1" fill="white"/>
        </svg>
      ),
      network: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2"/>
          <circle cx="12" cy="12" r="1" fill="white"/>
          <circle cx="12" cy="5" r="2" stroke="white" strokeWidth="2"/>
          <circle cx="5" cy="19" r="2" stroke="white" strokeWidth="2"/>
          <circle cx="19" cy="19" r="2" stroke="white" strokeWidth="2"/>
          <line x1="12" y1="7" x2="12" y2="9" stroke="white" strokeWidth="2"/>
          <line x1="9.17" y1="14.17" x2="6.83" y2="17.83" stroke="white" strokeWidth="2"/>
          <line x1="14.83" y1="14.17" x2="17.17" y2="17.83" stroke="white" strokeWidth="2"/>
        </svg>
      ),
      people: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21" stroke="white" strokeWidth="2"/>
          <circle cx="9" cy="7" r="4" stroke="white" strokeWidth="2"/>
          <path d="M22 21V19C22 18.1332 21.7361 17.2863 21.2428 16.5745C20.7495 15.8627 20.0506 15.3209 19.24 15.0209" stroke="white" strokeWidth="2"/>
          <path d="M16 3.12988C16.8115 3.4309 17.5108 3.97375 18.0043 4.68668C18.4978 5.39962 18.7619 6.24742 18.7619 7.11538C18.7619 7.98335 18.4978 8.83115 18.0043 9.54409C17.5108 10.257 16.8115 10.7999 16 11.1009" stroke="white" strokeWidth="2"/>
        </svg>
      ),
      support: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2"/>
          <circle cx="12" cy="12" r="6" stroke="white" strokeWidth="2"/>
          <circle cx="12" cy="12" r="2" fill="white"/>
        </svg>
      ),
      hardware: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="4" width="20" height="16" rx="2" stroke="white" strokeWidth="2"/>
          <rect x="6" y="8" width="4" height="8" fill="white"/>
          <rect x="14" y="8" width="4" height="8" fill="white"/>
          <line x1="6" y1="2" x2="6" y2="4" stroke="white" strokeWidth="2"/>
          <line x1="10" y1="2" x2="10" y2="4" stroke="white" strokeWidth="2"/>
          <line x1="14" y1="2" x2="14" y2="4" stroke="white" strokeWidth="2"/>
          <line x1="18" y1="2" x2="18" y2="4" stroke="white" strokeWidth="2"/>
        </svg>
      ),
      handshake: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 17C11 18.1046 10.1046 19 9 19C7.89543 19 7 18.1046 7 17C7 15.8954 7.89543 15 9 15C10.1046 15 11 15.8954 11 17Z" stroke="white" strokeWidth="2"/>
          <path d="M17 17C17 18.1046 16.1046 19 15 19C13.8954 19 13 18.1046 13 17C13 15.8954 13.8954 15 15 15C16.1046 15 17 15.8954 17 17Z" stroke="white" strokeWidth="2"/>
          <path d="M7 17H4C3.46957 17 2.96086 16.7893 2.58579 16.4142C2.21071 16.0391 2 15.5304 2 15V13C2 11.8954 2.89543 11 4 11H6" stroke="white" strokeWidth="2"/>
          <path d="M13 17H11" stroke="white" strokeWidth="2"/>
          <path d="M17 17H20C20.5304 17 21.0391 16.7893 21.4142 16.4142C21.7893 16.0391 22 15.5304 22 15V13C22 11.8954 21.1046 11 20 11H18" stroke="white" strokeWidth="2"/>
          <path d="M6 11V8C6 6.89543 6.89543 6 8 6H16C17.1046 6 18 6.89543 18 8V11" stroke="white" strokeWidth="2"/>
        </svg>
      )
    };

    return iconMap[iconType] || iconMap.presentation;
  };

  return (
    <div style={{
      marginBottom : '50px',
      minHeight: '100vh',
      backgroundColor: '#FAFBFC',
      padding: '20px 10px',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      <div className="container-fluid">
        {/* Header */}
        <div className="row mb-5">
          <div className="col-12">
            <h1 style={{
              fontSize: '3.5rem',
              fontWeight: '800',
              marginBottom: '0',
              letterSpacing: '1px'
            }}
            className='text-danger text-center title split-collab'
            >
              CRISIS MANAGEMENT
            </h1>
          </div>
        </div>

        {/* Main Content */}
        <div className="row">
          {/* Left Side - Images */}
          <div className="col-12 col-lg-5 mb-4 mb-lg-0"
        data-sal-delay="150"
        data-sal="slide-up"
        data-sal-duration="800"
          >
            {/* First Image Placeholder */}
            <div style={{
              backgroundImage : "url('../assets/images/CRISIS_MANAGEMENT/Picture1.png')",
              border: '3px solid #CBD5E0',
              backgroundSize : "cover",
              // objectFit : 'contain',
              borderRadius: '8px',
              height: '300px',
              marginBottom: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#718096',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              {/* <div className="text-center">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#A0AEC0',
                  borderRadius: '8px',
                  margin: '0 auto 10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                  </svg>
                </div>
                Exam Center Image 1
              </div> */}
            </div>

            {/* Second Image Placeholder */}
            <div style={{
              backgroundImage : "url('../assets/images/CRISIS_MANAGEMENT/Picture2.png')",
              border: '3px solid #CBD5E0',
              borderRadius: '8px',
              backgroundSize : "cover",
              height: '300px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#718096',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              {/* <div className="text-center">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#A0AEC0',
                  borderRadius: '8px',
                  margin: '0 auto 10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                  </svg>
                </div>
                Exam Center Image 2
              </div> */}
            </div>

            {/* Buffer Centre Note */}
            <div style={{
              marginTop: '20px',
              fontSize: '18px',
              fontWeight: '600',
              color: '#2D3748',
              textAlign: 'center'
            }}>
              (Buffer Centre booked in the case of)
            </div>
          </div>

          {/* Right Side - Crisis Items */}
          <div className="col-12 col-lg-7"
        data-sal-delay="150"
        data-sal="slide-up"
        data-sal-duration="800"
          >
            <div className="row g-4">
              {crisisItems.map((item, index) => (
                <div key={item.id} className="col-12">
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'white',
                    height: 100,
                    padding: '0',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    border: '1px solid #E2E8F0',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                  }}
                  >
                    {/* Icon Circle */}
                    <div style={{
                      width: '40px',
                      height: '40px',
                      backgroundColor: item.color,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '20px',
                      flexShrink: 0,
                      boxShadow: `0 4px 15px ${item.color}40`
                    }}>
                      {getIconComponent(item.icon, item.color)}
                    </div>

                    {/* Text Content */}
                    <div style={{
                      flex: 1,
                      padding: '20px 20px 20px 0',
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#2D3748',
                      lineHeight: '1.5'
                    }}>
                      {item.title}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrisisManagement;